module.exports = __webpack_public_path__ + "static/img/login-box-left.5daabe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/login-box-left.png
// module id = eoLU
// module chunks = 1